import { Chip } from '@mui/material';

import { useProfesional } from '@/features/profesionales/hooks/useProfesionales';

interface ProfesionalFiltroChipProps {
  uidProfesional: string;
  onClear: () => void;
}

export function ProfesionalFiltroChip({
  uidProfesional,
  onClear,
}: ProfesionalFiltroChipProps): JSX.Element {
  const { data: profesional, isLoading } = useProfesional(uidProfesional);

  const label = isLoading
    ? 'Cargando...'
    : profesional
      ? `Filtrando por: ${profesional.nombre_apellido}`
      : `Filtrando por profesional: ${uidProfesional.slice(0, 8)}...`;

  return (
    <Chip label={label} onDelete={onClear} color="primary" variant="outlined" />
  );
}
